import script from "./AiConfiguratorShopPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AiConfiguratorShopPopup.vue?vue&type=script&setup=true&lang=js"

import "./AiConfiguratorShopPopup.vue?vue&type=style&index=0&id=bcb8d8c2&scoped=true&lang=css"

import exportComponent from "/Users/marcin/Local Sites/ovalia/app/public/wp-content/themes/ovalia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb8d8c2"]])

export default __exports__